import React from 'react';

const ConsultForm = ({ consultationId, loading, error, handleChange, handleSubmit }) => {
  return (
    <div>
      <div className="search">
        <h4>Calculate CPT code for a completed consultation</h4>
        <form onSubmit={handleSubmit}>
          <table className="fields">
            <tbody>
              <tr>
                <th><label htmlFor="consultation_id">Consultation ID</label></th>
                <td>
                  <input type="text" name="consultation_id" value={consultationId} onChange={handleChange} />
                  {error && <span className="error">{error}</span>}
                </td>
              </tr>
            </tbody>
          </table>
          <button type="submit" className="button" disabled={loading}>Calculate CPT code</button>
        </form>
      </div>

    </div>
  );
};

export default ConsultForm;
